"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var common_1 = require("@angular/common");
var scrollable_directive_1 = require("./scrollable.directive");
exports.NguiScrollableDirective = scrollable_directive_1.NguiScrollableDirective;
var NguiScrollableModule = (function () {
    function NguiScrollableModule() {
    }
    return NguiScrollableModule;
}());
NguiScrollableModule = __decorate([
    core_1.NgModule({
        imports: [common_1.CommonModule, forms_1.FormsModule],
        declarations: [scrollable_directive_1.NguiScrollableDirective],
        exports: [scrollable_directive_1.NguiScrollableDirective]
    }),
    __metadata("design:paramtypes", [])
], NguiScrollableModule);
exports.NguiScrollableModule = NguiScrollableModule;
//# sourceMappingURL=scrollable.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/scrollable/dist/scrollable.module.js
// module id = 557
// module chunks = 4